module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black-891c4a7c7e644c9075aa0bb85eeeffd8.png";